// extracted by mini-css-extract-plugin
module.exports = {"container":"personal-info-form_container__sMBpc","submit":"personal-info-form_submit__PfN8w"};